import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "title-big t-blue uppercase text-center" }
const _hoisted_2 = { class: "form-wrapper mt-4" }
const _hoisted_3 = { class: "uppercase text-raleway-13" }
const _hoisted_4 = ["value"]
const _hoisted_5 = {
  key: 0,
  class: "text-raleway-13 t-danger"
}
const _hoisted_6 = { class: "d-flex j-content-s-be forgot-password-wrapper" }
const _hoisted_7 = { class: "d-flex a-i-center forgot-password" }
const _hoisted_8 = { class: "text-center text-raleway-13 pl-1" }
const _hoisted_9 = { class: "wrapper information mt-2 mb-2" }
const _hoisted_10 = { class: "text text-raleway-13" }
const _hoisted_11 = {
  class: "btn btn-default login",
  type: "submit"
}

import { changeComponentAuthorization } from "../../utils/component/component";
import { loginValidation } from "../../utils/validation/login";
import { LoginType, ErrorLoginType } from "./type";
import { change } from "@/hook/change/change";
import { ref, computed, onBeforeMount, watch } from "vue";
import { store } from "@/store";

import PasswordComponent from "../password/passwordComponent.vue";
import { SeoDescription, SeoTitle } from "@/utils/seo/seo";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginComponents',
  setup(__props) {

const userData = ref<LoginType>(store.getters.getUserDataLogin);
const isErrorFetch = ref(computed<boolean>(() => store.getters.errorGet));
const dataInput = ref<LoginType>({
  email: userData.value.email,
  password: userData.value.password,
  remember_me: false,
});
const errorMessageFetch = ref(computed<string>(() => store.getters.messageGet));
const rememberUser = ref(
  computed<boolean>(() => store.getters.getUserRemembeValue)
);
const error = ref<ErrorLoginType>({
  password: false,
  login: false,
  password_confirm: false,
});

const ch = (event: Event) => {
  store.commit("updateUserDataLogin", dataInput.value);
  change(event, dataInput);
};

const sendUserData = async (event: Event) => {
  event.preventDefault();
  if (rememberUser.value) dataInput.value.remember_me = true;
  loginValidation(dataInput, error);
};

onBeforeMount(() => {
  const uiLang = ref(computed<string>(() => store.getters.getUserUiLang));

  switch (uiLang.value.toUpperCase()) {
    case "SWEDISH":
      SeoTitle("Tyre point: Logga in");
      SeoDescription(
        "Tire Points nätbutik säljer bildäck. Vi erbjuder ett brett utbud av rabatterade däck och fälgar i Europa."
      );
      break;
    case "FINLAND":
      SeoTitle("Tyre point: Kirjaudu sisään");
      SeoDescription(
        "Tyre Point - verkkokauppa myy autonrenkaita. Tarjoamme laajan valikoiman edullisia renkaita ja vanteita Euroopassa."
      );
      break;
    default:
      SeoTitle("Tyre point: Login");
      SeoDescription(
        "The Tyre Point online store sells car tires. We offer a wide range of discount tires and rims in Europe."
      );
      break;
  }
});

const uiLang = ref(computed<string>(() => store.getters.getUserUiLang));
watch(
  () => uiLang.value,
  () => {
    switch (uiLang.value.toUpperCase()) {
      case "SWEDISH":
        SeoTitle("Tyre point: Logga in");
        SeoDescription(
          "Tire Points nätbutik säljer bildäck. Vi erbjuder ett brett utbud av rabatterade däck och fälgar i Europa."
        );
        break;
      case "FINLAND":
        SeoTitle("Tyre point: Kirjaudu sisään");
        SeoDescription(
          "Tyre Point - verkkokauppa myy autonrenkaita. Tarjoamme laajan valikoiman edullisia renkaita ja vanteita Euroopassa."
        );
        break;
      default:
        SeoTitle("Tyre point: Login");
        SeoDescription(
          "The Tyre Point online store sells car tires. We offer a wide range of discount tires and rims in Europe."
        );
        break;
    }
  },
  {
    deep: true,
  }
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("form", {
    class: "form pt-5",
    onSubmit: sendUserData
  }, [
    _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$tc("login_account")), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["input-wrapper mb-2", { 'error-input': error.value.login }])
      }, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$tc("username")), 1),
        _createElementVNode("input", {
          maxlength: "55",
          onInput: ch,
          type: "text",
          name: "email",
          class: "input",
          autocapitalize: "off",
          value: dataInput.value.email
        }, null, 40, _hoisted_4)
      ], 2),
      _createVNode(PasswordComponent, {
        error: error.value.password,
        change: ch,
        name: 'password',
        value: dataInput.value.password
      }, null, 8, ["error", "value"]),
      (isErrorFetch.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$tc(errorMessageFetch.value)), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("input", {
            class: "checkbox",
            type: "checkbox",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(store).commit('changeUserRemembeValue', !rememberUser.value)))
          }),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$tc("Remember me")), 1),
          _createVNode(_component_router_link, {
            class: "text text-raleway-13 error pointer t-danger capitalize ml-1",
            to: { name: 'private_policy' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$tc("privacy_policy")), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("p", {
          class: "text-raleway-13 pr-1 pointer",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(changeComponentAuthorization)('change_password')))
        }, _toDisplayString(_ctx.$tc("fargot_password")), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$tc("Not registered?")), 1),
        _createElementVNode("span", {
          class: "text text-raleway-13 error pointer t-danger p-1",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(changeComponentAuthorization)('create_account')))
        }, _toDisplayString(_ctx.$tc("Create an account")), 1)
      ]),
      _createElementVNode("button", _hoisted_11, _toDisplayString(_ctx.$tc("login")), 1)
    ])
  ], 32))
}
}

})